import { alpha } from '@mui/material/styles';

const scrollbarCustom = {
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.1) transparent',

  '&::-webkit-scrollbar': {
    width: '5px',
    height: '5px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    border: '1px solid transparent',
    backgroundClip: 'padding-box',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
  },
};
const FIGMA_SHADOW = '2px 4px 4px 0px rgba(0, 0, 0, 0.15)';
const REFINED_DIVIDER = '1px solid rgba(0, 0, 0, 0.08)';
const BRAND_COLOR = '#4A3DFF';

export const styles = {
  columnLayout: {
    display: 'flex',
    height: '100vh',
    bgcolor: 'background.neutral',
    overflow: 'hidden',
  },
  cardBase: {
    bgcolor: '#FFFFFF',
    backdropFilter: 'blur(10px)',
    border: REFINED_DIVIDER,
    boxShadow: FIGMA_SHADOW,
    borderRadius: '16px',
    p: 2,
    ...scrollbarCustom,
  },
  actionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: 'background.paper',
    backdropFilter: 'blur(12px) saturate(180%)',
    WebkitBackdropFilter: 'blur(12px) saturate(180%)', // Safari compatibility
    transform: 'translateZ(0)', // Forces stable GPU layer to eliminate the seam
    borderBottom: '1px solid',
    borderColor: 'divider',
    padding: '10px 20px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  tagPillStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '16px',
    bgcolor: '#EEF0F2',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
    px: 1.5,
    py: 0.2,
    minWidth: 'fit-content',
  },
  tagTextStyle: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#121212',
  },
  tagConnector: {
    width: '30px',
    height: '1.2px',
    bgcolor: 'rgba(0, 0, 0, 0.1)',
    mx: 0.5,
  },
  bubbleBase: {
    maxWidth: '75%',
    padding: '12px 20px',
    borderRadius: '3px',
    fontSize: '1rem',
    position: 'relative',
    transition: 'all 0.2s ease',
  },
  systemPill: {
    bgcolor: '#EEF0F2',
    color: '#3f4a53',
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '8px 24px',
    borderRadius: '30px',
    textAlign: 'center',
    margin: '20px auto',
    width: 'fit-content',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid rgba(0,0,0,0.04)',
  },
};

// --- LEGACY EXPORTS (FIXED SYNTAX) ---

export const appStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

export const cardStyle = styles.cardBase;

export const thirdGridStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};

export const secondTypographyStyle = {
  fontWeight: 700,
  color: '#121212',
  mb: 1,
};

export const thirdTypographyStyle = {
  fontWeight: 500,
  color: 'text.secondary',
};

export const forthTypographyStyle = {
  fontWeight: 600,
  color: 'text.primary',
};

export const appOrderTimelineStyle = {
  ...styles.cardBase,
  mt: 2,
};

export const scrollbarStyle = {
  maxHeight: 200,
  overflowY: 'auto',
  ...scrollbarCustom,
};

export const scrollbarStyle2 = {
  maxHeight: '70vh',
  overflowY: 'auto',
  ...scrollbarCustom,
};

// --- MODAL & BUTTON COMPATIBILITY ---

export const cardTicketModalStyle = styles.cardBase;

export const listTicketModalStyle = {
  ...scrollbarCustom,
};

export const loadingButtonStyle = {
  bgcolor: BRAND_COLOR,
  color: '#FFF',
  fontWeight: 600,
  borderRadius: '12px',
  height: '48px',
  px: 4,
  boxShadow: '0px 8px 16px 0px rgba(74, 61, 255, 0.24)',
  textTransform: 'none',
  '&:hover': {
    bgcolor: '#1A1A1A',
    boxShadow: 'none',
  },
};

export const secondButtonStyle = {
  bgcolor: '#FFF',
  color: BRAND_COLOR,
  border: `1px solid ${BRAND_COLOR}`,
  fontWeight: 600,
  borderRadius: '12px',
  height: '48px',
  px: 4,
  textTransform: 'none',
  '&:hover': {
    bgcolor: alpha(BRAND_COLOR, 0.04),
  },
};

export const typographyContentStyle = {
  fontWeight: 500,
  fontSize: '0.875rem',
  color: 'text.secondary',
  mb: 1,
};

export const attachmentsContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  p: 1,
};

export const attachmentsHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '12px 12px 0 0',
  bgcolor: '#F4F6F8',
  border: REFINED_DIVIDER,
  borderBottom: 'none',
  py: 1,
  px: 1,
};

export const attachmentListStyle = {
  px: 1,
  bgcolor: '#FFF',
  border: REFINED_DIVIDER,
  borderRadius: '0 0 12px 12px',
  maxHeight: '350px',
  overflowY: 'auto',
  ...scrollbarCustom,
};

export const listItemStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 500,
};

export const attachmentsloadingButtonStyle = loadingButtonStyle;

export const typographyStyle = {
  fontWeight: 700,
  fontSize: '0.9rem',
  ml: 1,
  color: '#121212',
};

export const listItemTicketModalStyle = (selected, user) => ({
  '&:hover': { backgroundColor: '#F5F5F5' },
  backgroundColor: selected?.id === user?.id ? alpha(BRAND_COLOR, 0.1) : 'transparent',
  cursor: 'pointer',
});

export const listItemTicketPermissionModalStyle = {
  '&:hover': { backgroundColor: '#F5F5F5' },
  cursor: 'pointer',
};
